import { Input, InputProps } from 'antd';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import SvgSearch from '../svg/SvgSearch';
import './style.scss';

export interface InputSearchProps extends InputProps {
  width?: number;
  onSearch?: () => void;
}

const InputSearch: FC<InputSearchProps> = (props) => {
  const { className, allowClear, onSearch, width, ...otherProps } = props;

  const intl = useIntl();

  return (
    <>
      <Input
        {...otherProps}
        allowClear={allowClear ? allowClear : false}
        className={`custom_input-search ${width ? `width-${width}` : ''} ${className || ''}`}
        suffix={
          <div className="custom_input-search-icon" onClick={onSearch}>
            <SvgSearch />
          </div>
        }
        placeholder={otherProps.placeholder || intl.formatMessage({ id: 'common.input.search.placeholder' })}
      />
    </>
  );
};

export default InputSearch;
